import { hotjar } from 'react-hotjar';

// This is harcoded because it shouldn't change that much
const HOTJAR_SNIPPET_VERSION = 6;

const initHotjar = ({
  id,
  company: { id: companyId },
  email,
  role
}: Pick<User, 'email' | 'id' | 'company' | 'role'>) => {
  const { HOTJAR_PROJECT_ID } = process.env;
  if (HOTJAR_PROJECT_ID && parseInt(HOTJAR_PROJECT_ID)) {
    hotjar.initialize(parseInt(HOTJAR_PROJECT_ID), HOTJAR_SNIPPET_VERSION);
    hotjar.identify(id.toString(), { companyId, email, role });
  }
};

export { initHotjar };
